// extracted by mini-css-extract-plugin
export default {"userInfoConatiner":"Surplus_userInfoConatiner__A6aam","userInfo":"Surplus_userInfo__wHPxi","showList":"Surplus_showList__vNdYL"};